function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.0600586 7C0.0600586 3.1402 2.94904 0 6.50006 0C10.0511 0 12.9401 3.1402 12.9401 7C12.9401 8.2654 12.626 9.50553 12.0317 10.5863L7.04989 19.6275C6.95376 19.8021 6.78088 19.9095 6.59373 19.9111H6.58947C6.40392 19.9111 6.2314 19.8069 6.13348 19.6353L1.02137 10.6809C0.392398 9.57678 0.0600586 8.3041 0.0600586 7ZM6.58135 18.2072L11.1106 9.98737C11.6052 9.08787 11.8703 8.0547 11.8703 7C11.8703 3.7835 9.45924 1.15889 6.50006 1.15889C3.54088 1.15889 1.12624 3.7835 1.12624 7C1.12624 8.08694 1.4101 9.14721 1.93363 10.0662L6.58135 18.2072Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.28027 7C3.28027 5.0701 4.72477 3.5 6.50027 3.5C8.27578 3.5 9.72028 5.0701 9.72028 7C9.72028 8.89649 8.32147 10.5 6.50027 10.5C4.70126 10.5 3.28027 8.91757 3.28027 7ZM4.34645 7C4.34645 8.28983 5.31041 9.34111 6.50027 9.34111C7.70899 9.34111 8.65051 8.27101 8.65051 7C8.65051 5.7134 7.68394 4.65889 6.50027 4.65889C5.3166 4.65889 4.34645 5.7134 4.34645 7Z",
  fill: "black"
});

function SvgMapPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/mapPin.5cb87042c02f5ab10bcc318e32f14511.svg";
export { ForwardRef as ReactComponent };